//@flow
import _ from 'lodash';
import * as React from 'react';
import { TableHeaderColumn } from 'react-bootstrap-table';
import connect from 'react-redux/es/connect/connect';
import TopoTitleComponente from '../../../components/PageTitle/TopoTitleComponente';
import ListagemPage from '../../../components/templates/ListagemPage';
import TopoListagem from '../../../components/Topo/TopoListagem';
import { objectsConstants } from '../../../_constants/objects.constants';
import { tableHelper } from '../../../_helpers/tableHelper';
import { IntegracaoSascConnectService } from '../../../_services/integracaoSascConnect.service';
import IntegracaoConnectListFilter from './IntegracaoConnectListFilter';
const columns = [
  {
    path: 'id',
    title: 'Identificador',
    isKey: true,
    dataSort: true,
    className: 'column-bold',
    // width: '33%',
  },
  {
    path: 'status',
    title: 'Situação',
    isKey: false,
    dataSort: true,
    className: 'column-bold',
    // width: '33%',
  },
  {
    path: 'marcacao.dataAtendimento',
    title: 'Data do Atendimento',
    isKey: false,
    dataSort: true,
    className: 'column-bold',
    // width: '33%',
  },
  {
    path: 'marcacao.medico.nome',
    title: 'Profissional de Saúde',
    isKey: false,
    dataSort: true,
    className: 'column-bold',
    // width: '33%',
  },
  {
    path: 'marcacao.paciente.nome',
    title: 'Paciente',
    isKey: false,
    dataSort: true,
    className: 'column-bold',
    // width: '33%',
  },
  {
    path: 'dataIntegracao',
    title: 'Data do envio',
    isKey: false,
    dataSort: true,
    className: 'column-bold',
    // width: '33%',
  },
  {
    path: 'data',
    title: 'Data do envio',
    isKey: false,
    dataSort: true,
    className: 'column-bold',
    // width: '33%',
  },
  // {
  //   path: 'recomendacoes',
  //   title: 'Recomendações',
  //   isKey: false,
  //   dataSort: true,
  //   // width: '33%',
  // },
];

const endPoint = '/sascconnect/novo';
const endPointView = '/sascconnect/view/';
class SascconnectListagemPage extends React.PureComponent<{}, State> {
  constructor(props) {
    super(props);

    let fields = _.map(
      _.filter(columns, function (coluna) {
        return !coluna.notExport;
      }),
      function (coluna) {
        return coluna.path;
      }
    );

    let labels = _.map(
      _.filter(columns, function (coluna) {
        return !coluna.notExport;
      }),
      function (coluna) {
        return coluna.title;
      }
    );
    this.state = {
      labels,
      fields,
    };
  }

  handleRowClick = (row: e) => {
    this.props.history.push(endPointView + row.id);
  };

  handleNewButton = (row: e) => {
    this.props.history.push(endPoint);
  };

  render() {
    const tableColumn = _.map(columns, (column, index) => (
      <TableHeaderColumn
        key={index}
        dataField={column.path}
        dataFormat={tableHelper.renderCustom}
        formatExtraData={column}
        isKey={column.isKey}
        dataSort={column.dataSort}
        hidden={column.hidden}
        width={column.width}
        className={column.classname}
      >
        {column.title}
      </TableHeaderColumn>
    ));

    let filter = {
      extension: this.props.extension
        ? this.props.extension
        : this.props.user.extension,
    };

    return (
      <React.Fragment>
        <TopoTitleComponente
          mainTitle={objectsConstants.TITULO_PAGINA_INTEGRACAO_SASCCONNECT}
          subTitle=" "
          canBack={false}
        />

        <TopoListagem
          securityActionDo={objectsConstants.VIEW}
          securityActionOn={objectsConstants.CRUD_INTEGRACAO}
          buttonActionClassName={'btn-light'}
          buttonAction={() => {
            // this.handleNewButton();
          }}
          securityActionIcon={'icon-btn-add'}
          securityActionName={'Novo exame'}
        ></TopoListagem>
        <ListagemPage
          title={`Integração Sascconnect`}
          showNewButton={false}
          delete={() => {}}
          service={IntegracaoSascConnectService}
          defaultOrder={'id'}
          defaultDirection={'desc'}
          defaultFilter={filter}
          onRowClick={this.handleRowClick}
          FormFilter={IntegracaoConnectListFilter}
          fields={this.state.fields}
          controller="api/sascconnect"
          labels={this.state.labels}
        >
          {tableColumn}
        </ListagemPage>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  return {
    user,
  };
}

export default connect(mapStateToProps)(SascconnectListagemPage);
